import React, { Component } from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import DataTypeList from './datatype_list';
import DataPipelineList from './pipelines_list';
import DataServicesList from './data_service_list';
import DataPipelineDetail from './pipeline_detail';
// import DataPipelineCreate from './pipeline_create';
// import DatatypeSourceList from '../sources/datatype_source_list';
import DatatypeBalances from './datatype_balances';
import DatatypeFlags from './datatype_flags';
import TransactionActionsList from './transaction_actions_list';

class DataTypeSetting extends Component {
  render() {
    return (
        <Switch>
        
        <Route path="/settings/datatype/:datatype_id/services" component={DataServicesList}/>
        <Route path="/settings/datatype/:datatype_id/balances" component={DatatypeBalances}/>
        <Route path="/settings/datatype/:datatype_id/labels"  component={DatatypeFlags}/>
        <Route path="/settings/datatype/:datatype_id/actions"  component={TransactionActionsList}/>
        {/* <Route path="/settings/datatype/:datatype_id/pipelines/create" component={DataPipelineCreate}/> */}
        <Route path="/settings/datatype/:datatype_id/pipelines/:pipeline_id" component={DataPipelineDetail}/>
        <Route path="/settings/datatype/:datatype_id/pipelines" component={DataPipelineList}/>
        <Redirect from="/settings/datatype/:datatype_id" to= "/settings/datatype"/>
        <Route path="/settings/datatype" component={DataTypeList}/>
        <Redirect from="*" to= "/settings/datatype"/>
    </Switch>
    );
  }
}

export default DataTypeSetting;
